// extracted by mini-css-extract-plugin
export var chapter = "Related-module--chapter--20b2a";
export var container = "Related-module--container--fa6c5";
export var inner = "Related-module--inner--c51f6";
export var intro = "Related-module--intro--5d2ae";
export var label = "Related-module--label--b1685";
export var title = "Related-module--title--a7d9d";
export var unit = "Related-module--unit--4c913";